export enum OnsiteCampaignStatus {
  LIVE = 'Live',
  TEST = 'Test',
  DRAFT = 'Draft',
}
